import { render } from "./Markdown.vue?vue&type=template&id=5e1dfb14&scoped=true"
import script from "./Markdown.vue?vue&type=script&lang=js"
export * from "./Markdown.vue?vue&type=script&lang=js"

import "./Markdown.vue?vue&type=style&index=0&id=5e1dfb14&scoped=true&lang=css"

import exportComponent from "/Users/sebi/www/screen-app/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1dfb14"]])

export default __exports__